import { SpectrePreset } from '@agentsoftware/spectre-ui';
import headlessUi from '@headlessui/tailwindcss';

/** @type {import('tailwindcss').Config} */
export default {
  presets: [SpectrePreset],
  content: [
    './vendor/laravel/framework/src/Illuminate/Pagination/resources/views/*.blade.php',
    './storage/framework/views/*.php',
    './resources/views/**/*.blade.php',
    './resources/js/**/*.vue',
    './resources/js/**/*.ts',
    './node_modules/@agentsoftware/spectre-ui/**/*.js',
  ],
  theme: {
    extend: {
      height: {
        'layout-dashboard': 'calc(100vh - 64px)',
      },
      minHeight: {
        'layout-dashboard': 'calc(100vh - 64px)',
      },
    },
  },
  plugins: [
    headlessUi,
  ],
};
